import React, { useState } from "react";
import "../App.css";
import "./questions.css";
import { Button, Card, CardBody, Form, FormLabel } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation, useNavigate } from 'react-router-dom';

const Question3 = () => {
  const navigate = useNavigate(); // used to pass data to the next page
  const location = useLocation(); // used to get data from the last page
  const queryParams = new URLSearchParams(location.search);
  const age = queryParams.get('age'); // get user's age info
  const lastPeriod = queryParams.get('lastPeriod'); // get user's last period info
  const [cycleLength, setCycleLength] = useState("");

  const handleChange = (e) => {
    setCycleLength(e.target.value);
  };

  // when user clicks next
  const handleSubmit = (e) => {
    e.preventDefault();
    // navigate to question 4 with data
    navigate(`/question4?age=${age}&lastPeriod=${lastPeriod}&cycleLength=${cycleLength}`);
  };

  // when user clicks skip
  const handleSkip = () => {
    console.log("User chose to skip");
    // navigate to question 4 with data
    navigate(`/question4?age=${age}&lastPeriod=${lastPeriod}&cycleLength=${cycleLength}`);
  };

  return (
    <div className="questions_container">
      <Card className="custom-card">
        <CardBody className="custom-body">
          <h5>To help us better predict your period cycle, please answer the following questions:</h5>
          <Card className="inner-card">
            <CardBody className="custom-body-inner">
            <a className="skip-button" onClick={handleSkip}>Skip</a>
              <Form onSubmit={handleSubmit}>
                <Form.Group>
                  <FormLabel className="question">How long is your average cycle length?</FormLabel>
                  <Form.Control className="custom-input"
                    type="number" // user must enter a number
                    id="cycleLength"
                    name="cycleLength"
                    placeholder="Enter number of days"
                    min="0" // user can't enter a value less than 0
                    value={cycleLength}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Button variant="primary" className="next-button" type="submit">Next</Button>
              </Form>
            </CardBody>
          </Card>
        </CardBody>
      </Card>
    </div>
  );
};

export default Question3;
